/**
 * 控制多个坐标点的变换
 */
class MultiAnimamte{
    constructor(config){
        this.ontransition = config.ontransition;

        this.onreverse = config.onreverse;

        this.transitions = config.transitions;

        this.reverse = config.reverse;

        this.duration = config.duration;

        if(this.reverse)
            this.reverseCurrent = false;

        var self = this;
        var onrun = (rate)=>{
            if(rate == 0) return;

            for(var index in self.transitions) {
                self.transition(self.transitions[index], rate, index)
            }
        };

        var oncompleteonce = ()=> {
            self.reverseCurrent = !self.reverseCurrent;

            if(self.onreverse)
                self.onreverse();
        }

        this.timeAnimate = new TimeAnimate({
            onrun,
            oncompleteonce,
            ...config
        });
    }
    run() {
        this.timeAnimate.run();
    }
    transition(transitionConfig, rate, $i) {
        var actions = transitionConfig.actions;

        for(var index in actions) {
            this.transitionAction(actions[index], rate)
        }

        if(this.ontransition)
            this.ontransition(transitionConfig, rate, $i);
    }
    transitionAction(action, rate) {
        var distance = 0;
        if(this.reverse && this.reverseCurrent) {
            distance = action.from - action.to;
            action.current = action.to + distance * rate;
        }else{
            distance = action.to - action.from;
            action.current = action.from + distance * rate;
        }
    }
}

/**
 * 控制时间执行bezier变换的逻辑
 * 从0到duration
 */
class TimeAnimate {
    constructor(config) {
        //最少一次
        this.times = config.times || 1;
        //控制点
        this.points = config.points || [{ x:0, y:0},{x:1, y:1}];
        //间隔
        this.duration = config.duration;
        //是否无限循环
        this.infinite = config.infinite;

        this.onrun = config.onrun;

        this.oncompleteonce = config.oncompleteonce;
    }
    calcRate(timeInterval, maxDuration, p0, p1) {
        if(timeInterval <= 0) return 0;

        if(timeInterval > maxDuration)
            timeInterval = maxDuration;

        var rate = timeInterval / maxDuration;

        return 3*p0.y*rate*Math.pow(1-rate, 2) 
        + 3*p1.y*Math.pow(rate, 2)*(1 - rate)
        + Math.pow(rate,3)
    }
    run() {
        this.start = new Date();

        this.animate();
    }
    animate() {
        var now = new Date();
        var timeInterval = now - this.start;

        if(timeInterval > this.duration) {
            if(this.oncompleteonce)
                this.oncompleteonce(this.times);

            this.times--;
            if(this.times == 0 && !this.infinite)
                //全部执行完成
                return;
            else{
                //重新开始计算
                this.start = new Date();
                this.animate();
            }

        }else{
            var rate = this.calcRate(timeInterval, this.duration, this.points[0], this.points[1]);

            if(this.onrun) this.onrun(rate);

            requestAnimationFrame(()=>{
                this.animate()
            });
        }
    }
}

export default MultiAnimamte


// WEBPACK FOOTER //
// ./src/api/animate.js


// WEBPACK FOOTER //
// ./src/api/animate.js